angular.module('memberPortal').controller('PerformWorkoutCtrl', ["$scope", "$rootScope", "$stateParams", "$state", "$modal", "Restangular", "UnitSymbols", "WorkoutService", "DataService", "workout", function($scope, $rootScope, $stateParams, $state, $modal, Restangular, UnitSymbols, WorkoutService, DataService, workout) {
  var parseTimeItem, pingIntervalId, prepareWorkout, recalculatePosition, recalculateWorkoutPosition, unsubscribe;
  $scope.pageParams = {};
  $scope.getHash = function() {
    return $stateParams.hash || $stateParams.m;
  };
  $scope.manageable = workout.manageable_by_member;
  $scope.unitSymbols = UnitSymbols;
  $scope.exercises = Restangular.all('exercises').getList({
    count: 3000
  }).$object;
  $scope.notDisplayOnly = function(exercise) {
    return exercise.exercise_type !== 'display_only';
  };
  pingIntervalId = window.setInterval(function() {
    return Restangular.all('members').customGET('ping');
  }, 120000);
  unsubscribe = $rootScope.$on('$stateChangeStart', function() {
    if (pingIntervalId) {
      window.clearInterval(pingIntervalId);
    }
    return unsubscribe();
  });
  recalculateWorkoutPosition = function() {
    recalculatePosition($scope.workout.performed_workout_exercises_attributes);
    return $scope.workout.performed_workout_exercises_attributes.forEach(function(exercise) {
      return recalculatePosition(exercise.performed_workout_sets_attributes);
    });
  };
  recalculatePosition = function(collection) {
    collection.forEach(function(item, index) {
      var removedItem;
      if (item._destroy) {
        removedItem = collection.splice(index, 1)[0];
        return collection.push(removedItem);
      }
    });
    return collection.forEach(function(item, index) {
      return item.position = index + 1;
    });
  };
  $scope.addExercise = function() {
    var exercise, newExercise;
    newExercise = $scope.pageParams.newExercise.plain();
    exercise = {
      exercise_id: newExercise.id,
      exercise_name: newExercise.name,
      exercise_description: newExercise.description,
      exercise_type: newExercise.exercise_type,
      exercise_video_url: newExercise.video_url,
      performed_workout_sets_attributes: [
        {
          position: 1,
          target_weight_unit: $scope.pageParams.targetWeightUnit,
          target_distance_unit: $scope.pageParams.targetDistanceUnit,
          actual_weight_unit: $scope.pageParams.targetWeightUnit,
          actual_distance_unit: $scope.pageParams.targetDistanceUnit
        }
      ]
    };
    $scope.workout.performed_workout_exercises_attributes.push(exercise);
    $scope.pageParams.newExercise = void 0;
    return recalculateWorkoutPosition();
  };
  $scope.removeExercise = function(index) {
    var exercise;
    exercise = $scope.workout.performed_workout_exercises_attributes[index];
    if (exercise.id) {
      exercise._destroy = 1;
    } else {
      $scope.workout.performed_workout_exercises_attributes.splice(index, 1);
    }
    return recalculateWorkoutPosition();
  };
  $scope.addSet = function(exerciseIndex) {
    var exercise, firstSet, set, targetDistanceUnit, targetWeightUnit;
    firstSet = $scope.workout.performed_workout_exercises_attributes[exerciseIndex].performed_workout_sets_attributes[0];
    targetWeightUnit = firstSet != null ? firstSet.target_weight_unit : void 0;
    targetDistanceUnit = firstSet != null ? firstSet.target_distance_unit : void 0;
    exercise = $scope.workout.performed_workout_exercises_attributes[exerciseIndex];
    set = {
      target_weight_unit: targetWeightUnit,
      target_distance_unit: targetDistanceUnit,
      actual_weight_unit: targetWeightUnit,
      actual_distance_unit: targetDistanceUnit
    };
    exercise.performed_workout_sets_attributes.push(set);
    return recalculateWorkoutPosition();
  };
  $scope.removeSet = function(exerciseIndex, setIndex) {
    var exercise, set;
    exercise = $scope.workout.performed_workout_exercises_attributes[exerciseIndex];
    set = exercise.performed_workout_sets_attributes[setIndex];
    if (set.id) {
      set._destroy = 1;
    } else {
      exercise.performed_workout_sets_attributes.splice(setIndex, 1);
    }
    return recalculateWorkoutPosition();
  };
  $scope.isRemoveAvailable = function(collection) {
    return $scope.manageable && _.filter(collection, function(item) {
      return !item._destroy;
    }).length > 1;
  };
  $scope.playExercise = function(exercise) {
    var modalInstance;
    return modalInstance = $modal.open({
      template: require('templates/member_portal/workouts/workout_video_modal.html.slim'),
      size: 'lg',
      resolve: {
        exercise: function() {
          return exercise;
        }
      },
      controller: ["$scope", "$modalInstance", "exercise", function($scope, $modalInstance, exercise) {
        $scope.exercise = exercise;
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
  };
  $scope.getPersonalBest = function(exercise) {
    return WorkoutService.getPersonalBest(exercise.personal_best);
  };
  parseTimeItem = function(item) {
    var itemText;
    if (item) {
      itemText = item.toString();
      if (itemText.length === 1) {
        return '0' + itemText;
      } else {
        return itemText;
      }
    } else {
      return '00';
    }
  };
  $scope.onTimeChanged = function(set, type) {
    var time, timeArray;
    time = set[`${type}_time`];
    timeArray = time.split(':').map(function(item) {
      return parseTimeItem(item);
    });
    set[`${type}_hours`] = timeArray[0];
    set[`${type}_minutes`] = timeArray[1];
    return set[`${type}_seconds`] = timeArray[2];
  };
  $scope.formatTimeField = function(set, type) {
    var hours, minutes, seconds;
    hours = parseTimeItem(set[`${type}_hours`]);
    minutes = parseTimeItem(set[`${type}_minutes`]);
    seconds = parseTimeItem(set[`${type}_seconds`]);
    return set[`${type}_time`] = hours && minutes && seconds ? [hours, minutes, seconds].join(':') : void 0;
  };
  $scope.hitTarget = function(set, type) {
    if (type === 'reps') {
      set.actual_reps = set.target_reps;
    }
    if (type === 'weight_and_reps' || type === 'weight_reps_time_distance') {
      set.actual_reps = set.target_reps;
      set.actual_weight = set.target_weight;
    }
    if (type === 'time_or_distance' || type === 'weight_reps_time_distance') {
      set.actual_distance_number = set.target_distance_number;
      set.actual_hours = set.target_hours;
      set.actual_minutes = set.target_minutes;
      set.actual_seconds = set.target_seconds;
      return $scope.formatTimeField(set, 'actual');
    }
  };
  $scope.displayHitTarget = function(set, type) {
    var timeOrDistance, weightAndReps;
    weightAndReps = (set.target_reps || set.target_weight) && !(set.actual_reps || set.actual_weight);
    timeOrDistance = (set.target_distance_number || set.target_hours || set.target_minutes || set.target_seconds) && !(set.actual_distance_number || set.actual_hours || set.actual_minutes || set.actual_seconds);
    switch (type) {
      case 'reps':
        return set.target_reps && !set.actual_reps;
      case 'weight_and_reps':
        return weightAndReps;
      case 'time_or_distance':
        return timeOrDistance;
      case 'weight_reps_time_distance':
        return weightAndReps && timeOrDistance;
    }
  };
  $scope.save = function() {
    $scope.isLoading = true;
    $scope.isError = false;
    return Restangular.all('performed_workouts').post($scope.workout).then(function(data) {
      DataService.member_details.workout_history_available = true;
      return $state.go('memberPortal.performedworkouts', {
        m: $scope.getHash()
      });
    }, function() {
      $scope.isLoading = false;
      return $scope.isError = true;
    });
  };
  prepareWorkout = function(workout) {
    var firstSet, ref, w;
    firstSet = (ref = workout.workout_exercises[0]) != null ? ref.workout_sets[0] : void 0;
    $scope.pageParams.targetWeightUnit = firstSet != null ? firstSet.target_weight_unit : void 0;
    $scope.pageParams.targetDistanceUnit = firstSet != null ? firstSet.target_distance_unit : void 0;
    w = workout.clone();
    w.performed_workout_exercises_attributes = w.workout_exercises.map(function(exercise) {
      exercise.performed_workout_sets_attributes = exercise.workout_sets.map(function(set) {
        set.contact_workout_set_id = set.id;
        set.actual_distance_unit = set.target_distance_unit;
        set.actual_weight_unit = set.target_weight_unit;
        $scope.formatTimeField(set, 'target');
        set.id = void 0;
        return set;
      });
      exercise.contact_workout_exercise_id = exercise.id;
      exercise.id = void 0;
      exercise.workout_sets = void 0;
      return exercise;
    });
    w.contact_workout_id = w.id;
    w.id = void 0;
    w.workout_exercises = void 0;
    w.contact = void 0;
    w.contact_id = void 0;
    w.rootObjectName = 'performed_workout';
    return w;
  };
  return $scope.workout = prepareWorkout(workout);
}]);
